// removed by extract-text-webpack-plugin
module.exports = {"box":"Box__box___28QkA","boxPadding":"Box__boxPadding___1JKaj"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/completeProfile/components/Box.scss
// module id = 1755
// module chunks = 0